import BaseComponent from 'foundation/base-component';
import pageSpinner from '../../../general/js/page-spinner';
import * as userAccountApi from '../../sso/store/api/user-account-api';

class BallotCtaComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.onClick = this.onClick.bind(this);
        this.init();
    }

    init() {
        this.element.addEventListener('click', this.onClick);
    }

    onClick(e) {
        e.preventDefault();
        pageSpinner.show();
        userAccountApi.authUserInBallotSecutix(this.options.actionResource)
            .then(() => {
                pageSpinner.hide();
                return Promise.resolve();
            })
            .catch((error) => {
                console.error(error);
                pageSpinner.hide();
                Promise.reject();
            });
    }
}

export default BallotCtaComponent;
